import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Typography } from "@mui/material";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import { getCookie } from "../../../utilities/cookies";
import PreviewAndSign from "../../../components/PreviewAndSign";
import axios from "axios";
import { useMessage } from "../../../components/Header";
import ShowStatus from "../../../components/Common/ShowStatus";
import DateFormate from "../../../components/Common/DateFormate";
import StatusBasedSearch from "../../../components/Common/StatusBasedSearch";
import SearchDocuments from "../../../components/Common/SearchDocuments";
import RangeDatePicker from "../../../components/Common/RangeDatePicker";
import {
  defaultSortModel,
  documentsRenameHandller,
  generateSingingLinkFunc,
  getDocumentsByStatus,
  movedToTrashDocuments,
} from "../Functions/document";
import {
  folderOptions,
  receivedDocumentsActivity,
} from "../../../services/options";
import DocumentOptions from "../../../components/Common/DocumentOptions";
import { useUser } from "../../../hooks/Authorize";
import MovedToFolder from "../../../components/MoveToFolder/MovedToFolder";
import BreadCrumbTable from "../../../components/Common/BreadCrumbTable";
import DocumentRenameTextField from "../../../components/Common/DocumentRenameTextField";
import CreateNewDocument from "../../../components/CreateNewDocument";
import useStyles from "../Style";
import Loading from "../../../components/Progress/Loading";
import { env } from "../../../utilities/function";
import { useTheme } from "../../../style/theme";
import {
  Card,
  CardContent,
  Chip,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { MoreVerticalIcon } from "lucide-react";
import { useTheme as useThemee } from "@mui/material/styles";

const Index = (props) => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [document, setDocument] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [signDocument] = React.useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [iseditableFIleName, setIsEditableFileName] = useState(false);
  const [fileName, setFileName] = useState(undefined);
  const user = JSON.parse(localStorage.getItem("user"));
  const [documentRow, setDocumentRow] = useState(null);
  const [documentRowId, setDocumentRowId] = useState();

  const lastFiveYearDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );
  const [breadrumbData, setBreadCrumbData] = useState([
    {
      name: "Documents",
      _id: null,
    },
  ]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: lastFiveYearDate,
    endDate: new Date(),
  });
  const { startDate, endDate } = selectedDateRange;
  const getRowId = (row) => row._id;
  const isEmpty = rows.length === 0 || filteredRows?.length === 0;
  const { showError, showSuccess } = useMessage();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  //This is for sign handller
  const signHandller = async () => {
    const response = await generateSingingLinkFunc(documentRow, user.email);
    if (response.status === 200) {
      try {
        const signingLink = `${window.location.origin}/otherSigner?signerAccessToken=${response.data.signerAccessToken}`;
        window.location.href = signingLink;
      } catch (err) {
        showError("Failed to generate signing link");
      }
    }
  };

  //This is for move to handller
  const moveToFolder = () => {
    setIsCreateModalOpen(true);
    setAnchorEl(null);
  };

  //This is for delete handller
  const onClickDocumentDeleteHandller = async () => {
    const responseMessage = await movedToTrashDocuments(documentRow?._id);
    if (responseMessage.status === 200) {
      showSuccess(responseMessage.message);
      fetchData();
      setAnchorEl(null);
    } else {
      showError(responseMessage.message);
    }
  };
  /**on click breadcrumb handller */
  const onClickBreadCrumbHandller = (_id) => {
    fetchData(_id);
    // Find the index of the item with the provided _id
    const indexToRemove = breadrumbData.findIndex((item) => item._id === _id);
    if (indexToRemove !== -1) {
      // If the item with the _id is found, remove all items to the right of that index
      setBreadCrumbData((prevList) => prevList.slice(0, indexToRemove + 1));
    }
  };
  /**This function for document rename */
  const documentsRename = async () => {
    const responseMessage = await documentsRenameHandller(
      documentRow?._id,
      fileName
    );
    if (responseMessage.status === 200) {
      showSuccess(responseMessage.message);
      fetchData();
      setAnchorEl(null);
      setIsEditableFileName(false);
    } else {
      showError(responseMessage.message);
    }
  };

  /**document rename handller */
  const onDocumentRenameChangeHandller = (e) => {
    const { value } = e.target;
    setFileName(value);
  };

  // file rename handller
  const documentFileRenameHandlller = () => {
    setIsEditableFileName(true);
    setAnchorEl(null);
  };
  const columns = [
    {
      field: "fileName",
      headerName: "TITLE",
      flex: 4,
      minWidth: 300,
      renderCell: (params) =>
        iseditableFIleName && documentRow?._id === params.row._id ? (
          <DocumentRenameTextField
            value={fileName}
            onChange={onDocumentRenameChangeHandller}
            onEnterPress={documentsRename}
          />
        ) : (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onDoubleClick={() =>
              params.row.status === "Folder"
                ? onDoubleClickFOlderHandller(
                    params.row._id,
                    params.row.fileName
                  )
                : {}
            }
          >
            <span>{params.row.fileName}</span>
            <ShowStatus
              backgroundColor={
                params.row.status === "Received" ? "#FFF2E6" : "#295C97"
              }
              color={params.row.status === "Received" ? "#F18653" : "white"}
              status={params.row.status}
            />
          </div>
        ),
    },
    {
      field: "createdAt",
      headerName: "Date Created",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,
      renderCell: (params) => (
        <DateFormate localFormate={params.row.createdAt} />
      ),
    },
    {
      field: "userName",
      headerName: "Created By",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1, // Takes 1 part of available space
      minWidth: 150, // Center header
      align: "center",
      renderCell: () => (
        <div>
          <Button aria-describedby={id} variant="text" onClick={handleClick}>
            <MoreVerticalIcon />
          </Button>
        </div>
      ),
    },
  ];

  const handleChange = (event) => {
    setDocument(event.target.value);
  };
  /**This function for onchange search */
  const onChangeSearchHandller = (event) => {
    const { value } = event.target;
    // Filter rows based on the search input
    const filteredData = rows.filter((row) =>
      row.fileName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filteredData);
  };
  /**date range picker */
  const onChangeHandleDatepicker = (dateStrings) => {
    if (dateStrings) {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: dateStrings[0],
        endDate: dateStrings[1],
      });
    } else {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: new Date(lastFiveYearDate),
        endDate: new Date(),
      });
    }
  };
  /**This is function for modal close */
  const handleCloseModal = () => {
    setIsCreateModalOpen(false);
  };
  const fetchData = async (folderId) => {
    try {
      const response = await getDocumentsByStatus(
        "Received",
        startDate,
        endDate,
        folderId
      );
      if (response.status === 200) {
        setRows(response.data); // Update the rows state with API data
        setIsLoading(false);
        setFilteredRows(response.data); // Initialize filteredRows with all
        handleCloseModal();
      } else {
        showError("Error fetching data");
      }
    } catch (error) {
      showError("Error fetching data");
    }
  };
  /**This is for go to folder innersection */
  const onDoubleClickFOlderHandller = (folderId, name) => {
    // Check if _id already exists in the breadCrumbList
    const isIdExist = breadrumbData.some((item) => item._id === folderId);
    if (!isIdExist) {
      // If _id does not exist, append it to the breadCrumbList
      setBreadCrumbData((prevList) => [...prevList, { name, _id: folderId }]);
    }
    fetchData(folderId);
  };
  const fetchFile = async (fileId) => {
    const accessToken = getCookie("accessToken");
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const response = await axios.get(
        env("BACKEND_SERVER") + "/document/file/private/" + fileId,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + accessToken,
          },
          withCredentials: false,
        }
      );
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(blob);
        setPdfFile(url);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  /* eslint-disable */
  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, [selectedDateRange]);
  /* eslint-disable */

  const TurnToTemplate = (documentFileId) => {
    navigate(`/templates/new?fileId=${documentFileId}`);
  };
  const theme = useTheme();

  const themee = useThemee();
  const isMobile = useMediaQuery(themee.breakpoints.down("sm"));
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          mt: 2,
          boxShadow: "none",
          border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
          padding: { xs: 0, sm: 3 },
          borderRadius: 2,
        }}
      >
        {isLoading && <Loading />}
        {signDocument && (
          <Grid item xs={12} sm={12}>
            <PreviewAndSign
              pdfFile={pdfFile}
              handleCloseFunc={() => {}}
            ></PreviewAndSign>
          </Grid>
        )}
        <Typography
          variant="h6"
          sx={{ paddingTop: { xs: 3, sm: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          {" "}
          Received Documents
        </Typography>
        <br />
        <Typography
          variant="body2"
          sx={{ paddingTop: { xs: 0, sm: 0 }, paddingLeft: { xs: 3, sm: 0 } , paddingRight: { xs: 3, sm: 0 },}}
          style={{ color: "#7d8d98" }}
          className="text-wrap"
        >
          Browse the documents sent by others for you to sign.
        </Typography>
        <br />
        <Grid
          container
          justifyContent={"space-between"}
          spacing={2}
          sx={{ paddingTop: { xs: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          <SearchDocuments onChangeSearchHandller={onChangeSearchHandller} />
          <StatusBasedSearch defaultStatus={`/documents/received`} />
          <RangeDatePicker handleDateChange={onChangeHandleDatepicker} />
        </Grid>
        {breadrumbData?.length > 1 ? (
          <BreadCrumbTable
            breadCrumbData={breadrumbData}
            onClick={onClickBreadCrumbHandller}
          />
        ) : (
          ""
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sx={{ marginTop: "25px" }}>
            <div className={classes.root}>
              {isEmpty ? (
                <CreateNewDocument />
              ) : isMobile ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
        paddingTop: 3,
                    paddingBottom: 3,
                    paddingRight: 0.5,
                    paddingLeft: 0.5,                     }}
                >
                  {filteredRows.map((row) => {
                    const statusColors = {
                      Draft: { bg: "#E6F4FC", text: "#7D8D98" },
                      Awaiting: { bg: "#FFF2E6", text: "#F18653" },
                      Completed: { bg: "#E3FFEA", text: "#4BC97E" },
                      Folder: { bg: "#295C97", text: "white" },
                      Received: { bg: "#FFF2E6", text: "#F18653" },
                    };
                    const colors = statusColors[row.status] || {
                      bg: "gray",
                      text: "gray",
                    };

                    return (
                      <Card
                        key={getRowId(row)}
                        sx={{
                          cursor: "pointer",
                          boxShadow: "none",
                          border: `1px solid ${
                            theme.mode === "dark" ? "#292929" : "#D6D6D6"
                          }`,
                          borderLeft: `4px solid ${colors.text}`,
                          borderRadius: 2,
                          "&:hover": { boxShadow: 6 },
                        }}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              {iseditableFIleName &&
                              documentRowId === row._id ? (
                                <DocumentRenameTextField
                                  value={fileName}
                                  onChange={onDocumentRenameChangeHandller}
                                  onEnterPress={documentsRename}
                                />
                              ) : (
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {row.fileName}
                                </Typography>
                              )}
                            </Box>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setDocumentRowId(row._id);
                                // setDocumentRow(row);
                                setDocumentType(row.status);
                                setAnchorEl(e.currentTarget);
                              }}
                            >
                              <MoreVerticalIcon />
                            </IconButton>
                          </Box>

                          {/* Status Badge */}
                          <Chip
                            label={row.status}
                            size="small"
                            sx={{
                              backgroundColor: colors.bg,
                              color: colors.text,
                              // mt: 1,
                              fontSize: "0.75rem",
                            }}
                          />

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mt: 1,
                            }}
                          >
                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                Created
                              </Typography>
                              <Typography variant="body2">
                                <DateFormate localFormate={row.createdAt} />
                              </Typography>
                            </Box>

                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                By
                              </Typography>
                              <Typography variant="body2">
                                {row.userName ? row.userName : "Not Completed"}
                              </Typography>
                            </Box>
                          </Box>

                          {row.status === "Folder" && (
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{ mt: 1.5 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                onDoubleClickFOlderHandller(
                                  row._id,
                                  row.fileName
                                );
                              }}
                            >
                              Open Folder
                            </Button>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              ) : (
                <DataGrid
                  rows={filteredRows}
                  columns={columns}
                  getRowId={getRowId}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  sortModel={defaultSortModel}
                  pageSizeOptions={[10]}
                  checkboxSelection
                  disableSelectionOnClick
                  disableColumnReorder={true}
                  onRowClick={(params) => {
                    setDocumentRowId(params.row._id);
                    setDocumentRow(params.row);
                    setFileName(params.row.fileName);
                    if (params.row.fileId) {
                      fetchFile(params.row.fileId); // Pass _id to fetchFile
                    }
                  }}
                />
              )}

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Stack direction="column" spacing={3} width={170}>
                  <FormControl id="buttonsID">
                    {(documentRow?.status === "Folder"
                      ? folderOptions
                      : documentRow?.status === "Received"
                      ? receivedDocumentsActivity
                      : []
                    )?.map((item, index) => {
                      return (
                        <DocumentOptions
                          id={item.id}
                          name={item.name}
                          src={item.src}
                          onClick={
                            item.id === "sign"
                              ? signHandller
                              : item.id === "moveto"
                              ? moveToFolder
                              : item.id === "delete"
                              ? onClickDocumentDeleteHandller
                              : item.id === "rename"
                              ? documentFileRenameHandlller
                              : item.id === "TurnToTemplate"
                              ? () => {
                                  TurnToTemplate(documentRowId);
                                }
                              : () => {}
                          }
                          key={index}
                        />
                      );
                    })}
                  </FormControl>
                </Stack>
              </Popover>
            </div>
          </Grid>
        </Grid>
        <MovedToFolder
          open={isCreateModalOpen}
          handleClose={handleCloseModal}
          documentId={documentRow?._id}
          handleSuccess={fetchData}
        />
      </Box>
      <div className="im-divider"></div>
    </>
  );
};

export default Index;
